/**
 * The type of events that can fly in the app dispatcher
 */
export const Events = {
  PAUSE: 'pause',
  SYNC: 'sync',
  UNPAUSE: 'unpause',
  AS_TEMPLATE: 'as_template',
}
